module.exports = __webpack_public_path__ + "static/media/usstruckee.8a2012ff.png";